export default __webpack_public_path__ + "static/audi-iconfont-73d5e9e628be743ce975b42238e67b7a.eot";